var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbedCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21284_1382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8 12.498L15.7666 14.198C15.4333 14.7647 14.7 14.9314 14.1666 14.598L12.9 13.8314C12.3666 14.2647 11.8 14.598 11.1666 14.8314V16.3314C11.1666 16.9647 10.6333 17.498 9.99998 17.498H7.99998C7.36664 17.498 6.83331 16.9647 6.83331 16.3314V14.8647C6.13331 14.598 5.49998 14.2314 4.96664 13.7647L3.66664 14.4647C3.09998 14.798 2.39998 14.5647 2.06664 14.0314L1.09998 12.298C0.766644 11.7314 0.999977 11.0314 1.53331 10.698L2.83331 9.99805C2.76664 9.66471 2.76664 9.33138 2.76664 8.99805C2.76664 8.59805 2.79998 8.19805 2.86664 7.83138L1.59998 7.06471C1.03331 6.73138 0.866644 5.99805 1.19998 5.46471L2.23331 3.76471C2.56664 3.19805 3.29998 3.03138 3.83331 3.36471L5.09998 4.13138C5.63331 3.69805 6.19998 3.36471 6.83331 3.13138V1.66471C6.83331 1.03138 7.36664 0.498047 7.99998 0.498047H9.99998C10.6333 0.498047 11.1666 1.03138 11.1666 1.66471V3.13138C11.8666 3.39805 12.5 3.76471 13.0333 4.23138L14.3 3.49805C14.8666 3.16471 15.5666 3.36471 15.9 3.93138L16.8666 5.66471C17.2 6.23138 16.9666 6.93138 16.4333 7.26471L15.1666 7.99805C15.2333 8.33138 15.2333 8.66471 15.2333 8.99805C15.2333 9.39805 15.2 9.76471 15.1333 10.1647L16.4 10.9314C16.9666 11.2314 17.1333 11.9647 16.8 12.498Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.498C7.63333 11.498 6.5 10.3647 6.5 8.99805C6.5 7.63138 7.63333 6.49805 9 6.49805C10.3667 6.49805 11.5 7.63138 11.5 8.99805C11.5 10.3647 10.3667 11.498 9 11.498Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21284_1382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedCalendar);
export default __webpack_public_path__ + "static/media/embed_calendar.bb8edcd49cc9e3690cddc33691cbd602.svg";
export { ForwardRef as ReactComponent };